"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const translate_1 = require("../helper/translate");
const ChartCustomizationModal = ({ gradientColors, setGradientColors, colors, setColors, data, isOpen, onClose, onSave, chartConfig }) => {
    const [width, setWidth] = (0, react_1.useState)(chartConfig.width || 600);
    const [height, setHeight] = (0, react_1.useState)(chartConfig.height || 400);
    const [barWidth, setBarWidth] = (0, react_1.useState)(chartConfig.barWidth || 10);
    const [barSpacing, setBarSpacing] = (0, react_1.useState)(chartConfig.barSpacing || 0.1);
    const [localColors, setLocalColors] = (0, react_1.useState)(colors); // Local state for managing color changes
    const [localGradientColors, setLocalGradientColors] = (0, react_1.useState)(gradientColors);
    (0, react_1.useEffect)(() => {
        setWidth(chartConfig.width || 600);
        setHeight(chartConfig.height || 400);
        setBarWidth(chartConfig.barWidth || 10);
        setBarSpacing(chartConfig.barSpacing || 0.1);
    }, [chartConfig.barSpacing, chartConfig.barWidth, chartConfig.height, chartConfig.width]);
    (0, react_1.useEffect)(() => {
        setLocalColors(colors);
    }, [colors]);
    (0, react_1.useEffect)(() => {
        setLocalGradientColors(gradientColors);
    }, [gradientColors]);
    const handleSubmit = () => {
        onSave({ width, height, barWidth, barSpacing });
        setColors(localColors);
        setGradientColors(localGradientColors);
        onClose();
    };
    if (!isOpen)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", { className: "modal", style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#00000080",
        }, children: (0, jsx_runtime_1.jsxs)("div", { className: "modal-content", style: {
                width: 500,
                padding: 15,
                height: 500,
                overflowY: "scroll",
                justifyContent: "space-between"
            }, children: [(0, jsx_runtime_1.jsx)("span", { onClick: onClose, style: {
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "flex-end",
                        fontSize: 20,
                    }, children: "\u00D7" }), (0, jsx_runtime_1.jsx)("h1", { children: (0, translate_1.translate)('Customize Chart') }), (0, jsx_runtime_1.jsxs)("label", { children: [(0, translate_1.translate)('Width'), ":", " ", (0, jsx_runtime_1.jsx)("input", { type: "number", className: "border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5", value: width, onChange: (e) => setWidth(Number(e.target.value)) })] }), (0, jsx_runtime_1.jsxs)("label", { children: [(0, translate_1.translate)('Height'), ":", " ", (0, jsx_runtime_1.jsx)("input", { type: "number", className: "border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5", value: height, onChange: (e) => setHeight(Number(e.target.value)) })] }), (0, jsx_runtime_1.jsxs)("label", { children: [(0, translate_1.translate)('Bar Width'), ":", " ", (0, jsx_runtime_1.jsx)("input", { type: "number", className: "border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5", value: barWidth, onChange: (e) => setBarWidth(Number(e.target.value)) })] }), (0, jsx_runtime_1.jsxs)("label", { children: [(0, translate_1.translate)('Bar Spacing'), ":", " ", (0, jsx_runtime_1.jsx)("input", { type: "number", className: "border mb-2 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5", step: "0.1", value: barSpacing, onChange: (e) => setBarSpacing(Number(e.target.value)) })] }), data.currentLevel === 2 ? (data.level2.series.map((series, index) => ((0, jsx_runtime_1.jsxs)("div", { style: {
                        display: "flex",
                        alignItems: "center",
                        marginBottom: 5,
                    }, children: [(0, jsx_runtime_1.jsxs)("label", { children: [series.name, ": "] }), (0, jsx_runtime_1.jsx)("input", { type: "color", style: { width: 20, height: 20, marginLeft: 5 }, value: localColors[index] || "#FFFFFF", onChange: (e) => {
                                const newColors = [...localColors];
                                newColors[index] = e.target.value;
                                setLocalColors(newColors);
                            } })] }, index)))) : ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("input", { type: "color", id: "startColor", value: localGradientColors[0], onChange: (e) => setLocalGradientColors([
                                e.target.value,
                                localGradientColors[1],
                            ]), style: { marginRight: 20 } }), (0, jsx_runtime_1.jsx)("input", { type: "color", id: "endColor", value: localGradientColors[1], onChange: (e) => setLocalGradientColors([
                                localGradientColors[0],
                                e.target.value,
                            ]) })] })), (0, jsx_runtime_1.jsx)("button", { onClick: handleSubmit, className: "btn", style: {
                        background: "#189CD8",
                        borderColor: "#28c76f",
                        color: "#fff",
                        marginTop: 15,
                    }, children: (0, translate_1.translate)('Customize') })] }) }));
};
exports.default = ChartCustomizationModal;
